<script>
import headBanner from './head';
import carSeries from './carSeries';
import activityform from './form';
import promotion from './promotion';
import autoShow from './autoShow';
import information from './information';
import coupon from './coupon';
import zanmap from './zanmap';
import recommend from './recommend';
import pathline from './pathline';
import scene from './scene';
import hotTopic from './hotTopic';
import zhibo from './zhibo';
import footerBtn from './footer';
import loading from '@/components/loading';
import store from './store/index.js';
export default {
    name: 'mainApp',
    data() {
        return {
            load: !window.__PRERENDER_INJECTED,
            cityName: '',
            cityId: ''
        };
    },
    components: {
        headBanner,
        carSeries,
        activityform,
        promotion,
        autoShow,
        coupon,
        zanmap,
        pathline,
        scene,
        hotTopic,
        zhibo,
        information,
        recommend,
        footerBtn,
        loading
    },
    computed: {
        isLoadingShow() {
            return store.loading.show;
        },
        loadingText() {
            return store.loading.text;
        },
        // 路线图 和文章列表 同时没有的时候不显示
        secondWrapShow() {
            return store.isShowSecondWrap;
        }
    }
}
</script>

<template>
    <div id="app">
        <head-banner></head-banner>
        <car-series></car-series>
        <activityform></activityform>
        <promotion v-if="load"></promotion>
        <!-- <auto-show></auto-show> -->
        <coupon></coupon>
        <!-- <zanmap></zanmap> -->
        <div class="secondWrap">
            <!-- <pathline></pathline> -->
            <!-- <scene></scene> -->
            <!-- <hot-topic></hot-topic> -->
            <!-- <zhibo></zhibo> -->
            <information></information>
        </div>
        <recommend></recommend>
        <footer-btn></footer-btn>
        <loading :status="isLoadingShow" :text="loadingText"></loading>
    </div>
</template>

<style lang="stylus" scoped>
#app
    overflow hidden
    background-color #850000
    font-size 0
    .secondWrap
        margin 0.8rem
        padding 0.53rem
        background rgba(255,138,93,0.18)
        border-radius 0.53rem
        border 0.05rem solid rgba(251,173,99,0.38)
</style>
<style lang="stylus">
#alertMes {
  position: fixed;
  z-index: 200;
  top: 50%;
  left: 50%;
  background-color: #000;
  opacity: 0.7;
  color: #fff;
  font-size: .86rem;
  padding: .54rem;
  border-radius: 8px;
  margin: -5.5rem 0 0 -5.5rem;
  width: 10rem;
  word-break: break-all;
  text-align: center;
}

</style>
